import {createSelector} from 'reselect';

export const myTeamsState = (state: any) => state.myTeams;

export const allViewTeams = createSelector(
  myTeamsState,
  myTeams => myTeams?.viewTeams ?? [],
);

export const viewTeamsByCoachId = allViewTeams;

export const hasTeamsByCoachId = createSelector(
  viewTeamsByCoachId,
  teams => Array.isArray(teams) && teams.length > 0,
);
export const selectedCoachId = createSelector(
  myTeamsState,
  myTeams => myTeams?.coachId || null,
);

export const reportFilterCount = createSelector(
  myTeamsState,
  myTeams => myTeams?.reportFilterCount || null,
);

export const reportCountAllOrg = createSelector(
  myTeamsState,
  myTeams => myTeams?.reportCountAllOrg || null,
);

export const viewTeamsState = createSelector(
  myTeamsState,
  myTeams => myTeams?.viewTeamsState || {},
);

export const isViewTeamState = createSelector(
  myTeamsState,
  state => state?.isViewTeam || false,
);

export const viewTeamsLoadingState = createSelector(
  viewTeamsState,
  state => state?.VIEW_TEAMS_LOADING_STATE || false,
);

export const myTeamsFilters = createSelector(
  myTeamsState,
  state => state?.filters || {},
);

export const selectedTab = createSelector(
  myTeamsState,
  state => state?.selectedTab || '',
);
